import { DateTime } from 'luxon';

export const userTimeZone = DateTime.local().zoneName;
// export const userTimeZone =  moment.tz.guess();
